import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

import Todos from "./components/Todos";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Welcome from "./components/Welcome";
import { RequireToken } from "./Auth.js";
import theme from "./theme";

function Home({ user_id }) {
  return (
    <ChakraProvider theme={theme}>
      <Todos user_id={user_id} />
    </ChakraProvider>
  );
}

function App() {
  const UserWrapper = () => {
    const { user_id } = useParams();
    return RequireToken({ user_id, children: <Home user_id={user_id} /> });
  };
  return (
    <div className="App">
      <ChakraProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/:user_id/todos" element={<UserWrapper />} />
        </Routes>
      </ChakraProvider>
    </div>
  );
}
export default App;
